import gql from 'graphql-tag';

export const GET_DEFAULT_SUB_INVENTORY_ACCOUNT_MAPPING = gql`
  query GetDefaultSubInventoryAccountMapping(
    $businessUnit: String
    $orderType: String
    $code: String
  ) {
    getDefaultSubInventoryAccountMapping(
      businessUnit: $businessUnit
      orderType: $orderType
      code: $code
    ) {
      id
      businessUnit
      orderType
      code
      defaultAccount
    }
  }
`;
